import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import AuthMiddleware from "./AuthMiddleware";
import { hasAuthToken } from "../common/localStorage";

const PrivateLayout = () => {
  if (!hasAuthToken()) {
    return <Navigate to="/" replace />;
  }

  return (
    <Sidebar>
      <AuthMiddleware>
        <Outlet />
      </AuthMiddleware>
    </Sidebar>
  );
};

export default PrivateLayout;
